import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import { Field, reduxForm, propTypes as formPropTypes} from 'redux-form/es'
import objectPath from 'object-path'
import {link as clientWebLink} from '../../../lib/clientweb'

import Panel from '../../layout/Panel'
import ModalLoader from '../../layout/ModalLoader'
import CenterSpinner from '../../layout/CenterSpinner'
import {isLoading} from 'mb-app-common/lib/util/loading'
import CheckboxOrRadioGroup from '../../forms/CheckboxOrRadioGroup'

import {getPreferences, setCommunicationType, PREFERENCES_GET, PREFERENCES_SET_COMMUNICATION_TYPE, COMMUNICATION_TYPE_NONE} from 'mb-app-common/store/actions/preferences'
import communicationLabels from 'mb-app-common/lib/data/communicationSettings'
import {communicationPrefSelector, communicationPrefValueSelector} from 'mb-app-common/store/selectors/preferences'



export class Communication extends Component{
	static propTypes = {
		dispatch: PropTypes.func.isRequired,
		preferences: PropTypes.object,
		isLoading: PropTypes.bool,
		isSetLoading: PropTypes.bool,
		email: PropTypes.string,
		phone: PropTypes.string,
		...formPropTypes
	};

	componentWillMount(){
		if(!this.props.preferences || Object.keys(this.props.preferences).length === 0){
			this.props.dispatch(getPreferences())
		}
	}

	formatLabel = (type) => {
		return type == "sms" ? type.toUpperCase() : type.split(/(?=[A-Z])/).map((p) => p.charAt(0).toUpperCase() + p.slice(1)).join(' ')
	}

	formatForForm(key, info){
		const values = Object.keys(this.props.preferences[key]).map((type) => ({
			value: type,
			disabled: type === 'push' || (type == "sms" && !this.props.phone) || (type == "email" && !this.props.email) || false,
			label: this.formatLabel(type)
		}))

		if(info.allowDoNotNotify){
			values.push({
				value: COMMUNICATION_TYPE_NONE,
				label: 'Do not notify'
			})
		}

		return values
	}

	onFieldChange(e, key, value, oldValue){
		if(Object.keys(this.props.initialValues).length > 0 && value !== oldValue){
			const save = () => this.props.dispatch(setCommunicationType(key, value))
				.catch(() => {
					alert('Error', 'Unable to save preference')
					this.props.change(key, oldValue)
				})

			if(value === COMMUNICATION_TYPE_NONE){
				if(confirm(communicationLabels[key].doNotNotifyText)){
					save()
				}else{
					e.preventDefault()
					//this.props.change(key, oldValue)
				}
			}else{
				return save()
			}
		}
	}

	render(){
		let {isLoading, isSetLoading, preferences, email, phone} = this.props
		return (
			<div>
				<h1 className="page-header">Communication Settings</h1>
				<Panel title='Preferences' subtitle="Update your alert preferences">
					<Choose>
						<When condition={preferences && Object.keys(preferences).length > 0}>
							<div className="alert alert-info">
								To turn on push notifications, using the MyBudget App go to Settings > Change Communication Settings.
							</div>
							<If condition={!email || !phone}>
								<div className="alert alert-info">
									Push notifications can only be configured on the MyBudget mobile application
								</div>
								<div className="alert alert-info">
									<If condition={!email}>
										<p>
											Email option is not available. There is no email preference set.
											{" "}<a href={clientWebLink('/preferences/personal')}>Edit</a>
										</p>
									</If>
									<If condition={!phone}>
										<p>
											Phone option is not available. There is no phone preference set.
											{" "}<a href={clientWebLink('/preferences/personal')}>Edit</a>
										</p>
									</If>
								</div>
							</If>
							<ModalLoader isLoading={isSetLoading}>
								<ul className="list-group">
									{
										Object.entries(communicationLabels).map(([title, prefs]) => {

											return (
												<li className="list-group-item" key={title}>
													<h4 className="list-group-item-heading">{prefs.name}</h4>
													<p className="help-text">{prefs.description}</p>
													<Field
														name={title}
														component={CheckboxOrRadioGroup.renderForForm}
														inputType="radio"
														values={this.formatForForm(title, prefs)}
														onChange={(e, value, oldValue) => this.onFieldChange(e, title, value, oldValue)}
													/>
												</li>
											)
										})
									}
								</ul>
							</ModalLoader>
						</When>
						<When condition={isLoading}>
							<CenterSpinner size="40px" />
						</When>
					</Choose>
				</Panel>
			</div>
		)
	}
}


export default connect((state) => {
	return {
		isLoading: isLoading(state.Loading[PREFERENCES_GET]),
		isSetLoading: isLoading(state.Loading[PREFERENCES_SET_COMMUNICATION_TYPE]),
		preferences: communicationPrefSelector(state),
		initialValues: communicationPrefValueSelector(state),
		email: objectPath.get(state.Preferences.remoteCommunication, ['personalDetails', 'email']),
		phone: objectPath.get(state.Preferences.remoteCommunication, ['personalDetails', 'phone']),
	}
})(reduxForm({
	form: 'CommunicationSettings',
	enableReinitialize: true,
	keepDirtyOnReinitialize: true
})(Communication))



// WEBPACK FOOTER //
// ./client/components/preferences/Communication/index.js